export default __webpack_public_path__ + "static/media/cvod-RP15.f3370210.svg";